import { ISubscriptionPlanCollection } from '../../models/collections/ISubscriptionPlanCollection';
import { apiV2 } from '../../api/ApiV2';

export const defaultCollection = {
  pageNo: 1,
  perPage: 100,
  items: [],
  itemsCount: 0,
  totalCount: 0,
  dataObjectParams: {
    _view_nested: true
  }
} as ISubscriptionPlanCollection;

const SubscriptionPlansLoader = () =>
  apiV2.crud
    .readCollection({
      dataObjectName: 'SubscriptionPlan',
      collectionParams: defaultCollection
    })
    .then(resp => resp.itemsCollection as ISubscriptionPlanCollection);

export default SubscriptionPlansLoader;
